import { ReactNode } from 'react';
import { TopNavigation } from './TopNavigation';

interface DesktopPageContainerProps {
  children: ReactNode;
  className?: string;
}

export function DesktopPageContainer({ 
  children, 
  className = ''
}: DesktopPageContainerProps) {
  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      {/* 상단 네비게이션 */}
      <TopNavigation />
      
      {/* 메인 콘텐츠 영역 - 상단 네비게이션 높이만큼 패딩 */}
      <main className="pt-[72px]">
        <div 
          className={`min-h-[calc(100vh-72px)] bg-white ${className}`}
          style={{ 
            paddingTop: '24px',
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingBottom: '24px'
          }}
        >
          {children}
        </div>
      </main>
    </div>
  );
}